import { IconButton } from '@web/components/atoms/Button'
import { ChevronLeftIcon, CircleTickIcon, Icon } from '@web/components/atoms/Icons'
import { Box, Center, Stack } from '@web/components/atoms/Layout'
import { Section2 } from '@web/components/atoms/Typography'
import { useMergeFields } from '@web/components/page-components/Text/MergeTags/MergeTag'
import { CAMPAIGN_MERGE_TAGS } from '@web/components/page-components/Text/MergeTags/utils'
import { useDonationFormContext } from '@web/components/page-components/DonationForm'

const [CampaignName] = CAMPAIGN_MERGE_TAGS

const DonationPostContactStep = () => {
  const campaignName = useMergeFields((state) => state.mergeFields.get(CampaignName.MergeFieldSettingId))
  const setStep = useDonationFormContext((state) => state.actions.setStep)

  return (
    <Center>
      <Box>
        <IconButton buttonAppearance="text" id="back-to-start" onClick={() => setStep(0)} size="md">
          <Icon w="36px" h="36px">
            <ChevronLeftIcon />
          </Icon>
        </IconButton>
      </Box>
      <Stack direction="row" alignItems="center">
        <CircleTickIcon boxSize="24px" />
        <Section2>
          Thank you for your interest in supporting our {campaignName}. One of our team will be in contact with you
          shortly.
        </Section2>
      </Stack>
    </Center>
  )
}

export default DonationPostContactStep
